import React from 'react';

import type { DesignVersion } from '../localStorage/designVersionLocalStorage';

export type DesignVersionContextValue = {
  isModernDesign: boolean;
  canUseModernDesign: boolean;
  designVersion: DesignVersion;
  setDesignVersion: (version: DesignVersion) => void;
  toggleDesignVersion: () => void;
};

export const DesignVersionContext = React.createContext<DesignVersionContextValue | null>(null);
